import {HttpHeaders} from '@angular/common/http';
import {
  AddParticipantResponse,
  Conference,
  ConferenceServiceInterface,
  Configuration,
  ConnectConferenceResponse,
  ConnectParticipantResponse,
  DisconnectConferenceResponse,
  DisconnectParticipantResponse,
  GetParticipantStatusResponse,
  GetReservedConferencesResponse,
  Participant,
  RemoveParticipantResponse,
  ReserveConferenceResponse,
  Response
} from '@gt-api';
import {MockData} from '@testhelper/mock-data';
import {Observable, of} from 'rxjs';

export class ConferenceServiceStub implements ConferenceServiceInterface {
  defaultHeaders: HttpHeaders = new HttpHeaders();
  configuration: Configuration;

  removeConference1(id: string, organization?: string, login?: string, extraHttpRequestParams?: any): Observable<Response> {
    return of({code: 200});
  }

  reserveConference1(organization?: string, login?: string, body?: Conference): Observable<ReserveConferenceResponse> {
    const response: ReserveConferenceResponse = {
      code: 200,
      message: null,
      exception: null,
      reservedConference: body
    };
    return of(response);
  }

  getReservedConferences1(): Observable<GetReservedConferencesResponse> {
    const response: GetReservedConferencesResponse = {
      code: 200,
      message: null,
      exception: null,
      reservedConferences: MockData.conferences
    };
    return of(response);
  }

  addParticipant1(conferenceId: string, organization?: string, login?: string, body?: Participant): Observable<AddParticipantResponse> {
    return of({code: 200});
  }

  connectConference1(
    payingParty: string,
    organization?: string,
    login?: string,
    body?: Array<Participant>
  ): Observable<ConnectConferenceResponse> {
    return of({code: 200});
  }

  connectParticipant1(
    conferenceId: string,
    organization?: string,
    login?: string,
    body?: Participant
  ): Observable<ConnectParticipantResponse> {
    return of({code: 200});
  }

  disconnectConference1(conferenceId: string, organization?: string, login?: string): Observable<DisconnectConferenceResponse> {
    return of({code: 200});
  }

  disconnectParticipant1(
    conferenceId: string,
    organization?: string,
    login?: string,
    body?: Participant
  ): Observable<DisconnectParticipantResponse> {
    return of({code: 200});
  }

  getParticipantStatus1(conferenceId: string, organization?: string, login?: string): Observable<GetParticipantStatusResponse> {
    return of({code: 200});
  }

  removeParticipant1(
    conferenceId: string,
    organization?: string,
    login?: string,
    body?: Participant
  ): Observable<RemoveParticipantResponse> {
    return of({code: 200});
  }
}
